import sendRequest from "../../../helpers/requestHelper";
import config from "../../../config";

const updateInvoice = {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {
        updateInvoiceRequest: function({ dispatch, rootState }, payload) {
            payload.creds.invoiceItems = rootState.saveInvoice.invoiceItems;
            dispatch('saveInvoice/requestDataSave', true, {root:true})
            let promise = sendRequest("put", config.baseURLApi + "/invoices/" + payload.creds.id, {}, payload.creds);
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch('saveInvoice/successDataSave', result[1], {root:true})
                } else {
                    dispatch('saveInvoice/failureDataSave', result[1], {root:true})
                }
            });
        },
    }
}

export default updateInvoice;